import { ModalMode } from "./types";

type ModalClassName = Record<ModalMode, { visible: string; invisible: string }>;

export const MODAL_CLASSNAME: ModalClassName = {
  notice: {
    visible:
      "visible fixed bottom-10 right-0 md:right-10 translate-x-0 transition-all duration-300 z-50",
    invisible:
      "invisible fixed bottom-10 right-0 translate-x-full transition-all duration-300 z-50",
  },
  default: {
    visible:
      "visible  absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 scale-100 opacity-100 rounded-lg transition-all duration-300 z-50",
    invisible:
      "invisible fixed top-1/2 translate-y-full left-1/2 -translate-x-1/2 scale-0 opacity-50 rounded-lg transition-all duration-300 z-50",
  },
} as const;

export const MODAL_OVERLAY_CLASSNAME: ModalClassName = {
  notice: {
    visible: "visible fixed top-0 left-0 w-full h-full z-50",
    invisible: "invisible fixed top-0 left-0 w-full h-full z-50",
  },
  default: {
    visible: "visible fixed top-0 left-0 bg-black-base/50 w-full h-full z-50",
    invisible: "invisible fixed top-0 left-0 w-full h-full z-50",
  },
} as const;
